<template lang="pug">
.pagination-loader
  pagination-loader-actions(
    :loading="loading"
    :no-more="noMore"
    :more-text="moreTextToShow"
    :no-more-text="noMoreText"
    :pagination="pagination"
    :page="page"
    :lastpage="lastpage"
    @prev="prev"
    @next="next")
</template>

<script>
import PaginationLoaderActions from "@/components/core/PaginationLoaderActions.vue";

export default {
  name: "PaginationLoader",
  components: {
    PaginationLoaderActions
  },
  props: {
    queryRef: {
      type: Object,
      required: true
    },
    moreText: {
      type: String
    },
    noMoreText: {
      type: String
    },
    immediate: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 10
    },
    pagination: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: [],
      loading: false,
      noMore: false,
      lastDoc: null,
      page: 0
    };
  },
  computed: {
    moreTextToShow() {
      return this.moreText || `顯示下 ${this.limit} 資料`;
    },
    lastpage() {
      return this.noMore ? Math.ceil(this.items.length / this.limit) : null;
    },
    currentItems() {
      if (!this.pagination) {
        return this.items;
      }

      const page = this.page;

      if (page === 0) return [];

      const limit = this.limit;
      const start = (page - 1) * limit;
      const end = start + limit;
      return this.items.slice(start, end);
    }
  },
  watch: {
    queryRef(v) {
      this.reload();
    },
    currentItems(n) {
      this.$emit("update", n);
    }
  },
  async mounted() {
    if (this.immediate) await this.next();
  },
  methods: {
    async load() {
      if (this.noMore) return false;

      this.loading = true;
      const snap = this.lastDoc
        ? await this.queryRef
            .startAfter(this.lastDoc)
            .limit(this.limit)
            .get()
        : await this.queryRef.limit(this.limit).get();

      if (snap.empty) {
        this.noMore = true;
      } else {
        this.lastDoc = snap.docs[snap.docs.length - 1];

        const list = this.$u.parseDbSnap(snap);
        this.items = this.items.concat(list);

        if (snap.size < this.limit) {
          this.noMore = true;
        }
      }

      this.loading = false;
    },
    async reload() {
      this.lastDoc = null;
      this.noMore = false;
      this.items = [];
      return this.load();
    },
    async next() {
      if (this.items.length <= this.page * this.limit) {
        await this.load();
      }
      this.page += 1;
    },
    prev() {
      this.page -= 1;
    },
    async reload() {
      this.noMore = false;
      this.lastDoc = null;
      this.items = [];
      this.page = 0;
      await this.next();
    }
  }
};
</script>
